import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDT } from "@/lib/format";
import { Input } from "@/components/ui/input";

export default function LedgerTab() {
  const [rows, setRows] = useState([]);
  const [sku, setSku] = useState("");

  useEffect(() => {
    const t = setTimeout(() => {
      api.get(`/stock/ledger${sku ? `?sku=${encodeURIComponent(sku)}` : ""}`).then((r) => setRows(r.data)).catch(() => setRows([]));
    }, 250);
    return () => clearTimeout(t);
  }, [sku]);

  return (
    <div className="space-y-3" data-testid="ledger-tab">
      <Input className="max-w-xs" placeholder="Filter by SKU" value={sku} onChange={(e) => setSku(e.target.value)} data-testid="ledger-sku-filter" />
      <div className="bg-card border border-border rounded-lg overflow-x-auto">
        <table className="w-full text-sm" data-testid="ledger-table">
          <thead><tr className="border-b border-border text-left">
            {["When", "User", "Type", "SKU", "Qty", "Bucket Move", "Location", "In", "Out", "Balance Δ", "Reference", "Reason", "Approver"].map((h) => (
              <th key={h} className="px-4 py-3 text-[10px] font-mono uppercase tracking-widest text-muted-foreground whitespace-nowrap">{h}</th>))}
          </tr></thead>
          <tbody>
            {rows.map((l, i) => (
              <tr key={l.ledger_id || `${l.at}-${l.transaction_type}-${l.sku}-${l.reference || "ref"}-${l.location || "loc"}-${i}`} className="border-b border-border/50" data-testid={`ledger-row-${i}`}>
                <td className="px-4 py-2.5 metric text-xs">{fmtDT(l.at)}</td>
                <td className="px-4 py-2.5 text-xs">{l.user_name} <span className="text-muted-foreground">({l.role})</span></td>
                <td className="px-4 py-2.5 text-[10px] font-mono uppercase">{l.transaction_type}</td>
                <td className="px-4 py-2.5 metric font-bold">{l.sku}</td>
                <td className="px-4 py-2.5 metric text-xs">{l.quantity ?? "—"}</td>
                <td className="px-4 py-2.5 text-[10px] font-mono">{(l.from_bucket || l.to_bucket) ? `${l.from_bucket || "—"} → ${l.to_bucket || "out"}` : "—"}</td>
                <td className="px-4 py-2.5 metric text-xs">{l.location || "—"}</td>
                <td className="px-4 py-2.5 metric text-signal-green">{l.qty_in || ""}</td>
                <td className="px-4 py-2.5 metric text-signal-red">{l.qty_out || ""}</td>
                <td className="px-4 py-2.5 metric font-bold">{l.prev_balance != null ? `${l.prev_balance} → ${l.new_balance ?? l.balance}` : l.balance}</td>
                <td className="px-4 py-2.5 metric text-xs">{l.reference || "—"}</td>
                <td className="px-4 py-2.5 text-xs max-w-48 truncate">{l.reason || "—"}</td>
                <td className="px-4 py-2.5 text-xs">{l.approver || "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={13} className="px-4 py-8 text-center text-muted-foreground">No ledger entries</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
